import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Typography, Button, Divider } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import CloseIcon from "@mui/icons-material/Close";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { updateEmployee } from "../../services/user.service";
import { FileUploader } from "react-drag-drop-files";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../context/AuthProvider";

const EditProfileUser = (props) => {
  const { setOpenDrawer, formType, GetData, selectedData } = props;
  const disabled = formType === "view";
  const { accessToken } = useAuth();
  const formRef = useRef(null);
  // const userData = selectedData.data;

  const initialValues = {
    firstName: selectedData?.data?.firstName,
    lastName: selectedData?.data?.lastName,
    email: selectedData?.data?.email,
    mobileNo: selectedData?.data?.mobileNo,
    dateOfBirth: selectedData.data?.dateOfBirth,
    emergencyDetails: {
      name: selectedData?.data?.emergencyDetails?.name,
      relation: selectedData?.data?.emergencyDetails?.relation,
      mobileNo: selectedData?.data?.emergencyDetails?.mobileNo,
    },
    address: {
      currentAddress: {
        doorNo_street:
          selectedData?.data?.address?.currentAddress?.doorNo_street,
        place: selectedData?.data?.address?.currentAddress?.place,
        pincode: selectedData?.data?.address?.currentAddress?.pincode,
        district: selectedData?.data?.address?.currentAddress?.district,
      },
    },
    file: selectedData?.data?.file?.fileName || null,
  };

  const [fileName, setFileName] = useState(
    formType === "add"
      ? selectedData?.data?.file?.fileName
      : "Drag & Drop or click to upload videos"
  );

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .required("Please enter email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address"
      )
      .test(
        "is-com",
        "Email must end with .com",
        (value) => value && value.endsWith(".com")
      ),
    mobileNo: Yup.string()
      .required("Mobile Number is required")
      .matches(
        /^[0-9]{10}$/,
        "Mobile Number must be 10 digits and contain only numbers"
      ),
    dateOfBirth: Yup.string().required("Select Date of Birth"),
    emergencyDetails: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      relation: Yup.string().required("Relation is required"),
      mobileNo: Yup.string()
        .required("Mobile Number is required")
        .matches(
          /^[0-9]{10}$/,
          "Mobile Number must be 10 digits and contain only numbers"
        ),
    }),
    address: Yup.object().shape({
      currentAddress: Yup.object().shape({
        doorNo_street: Yup.string().required("Door No / Street is required"),
        place: Yup.string().required("Place is required"),
        pincode: Yup.string()
          .required("Pincode is required")
          .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),
        district: Yup.string().required("District is required"),
      }),
    }),
  });

  //decodeToken
  const getUserIdFromToken = () => {
    // const token = localStorage.getItem("token");
    if (!accessToken) return null;

    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  // const GetProjectData = () => {
  //   getProject()
  //     .then((res) => {
  //       const configData = res.data.map((e) => {
  //         return {
  //           label: e.name,
  //           projectId: e._id,
  //         };
  //       });
  //       setProjectData(configData);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // };

  // useEffect(() => {
  //   // GetProjectData();
  //   if (formType === "edit" || formType === "view") {
  //     setInitialValues({
  //       name: selectedData.name || "",
  //       email: selectedData.email || "",
  //       userName: selectedData.userName || "",
  //       mobileNo: selectedData.mobileNo || "",
  //       employeeJoinDate: selectedData.employeeJoinDate || "",
  //       password: selectedData.password || "",
  //       confirmPassword: selectedData.password || "", // Set confirmPassword when editing
  //     });
  //   }
  // }, [formType, selectedData]);
  const onSubmit = (values) => {
    // const id = localStorage.getItem("_id");
    const id = getUserIdFromToken();
    const formData = new FormData();
    const { file, ...bodyData } = values;

    if (file) {
      formData.append("file", file);
    }
    formData.append("bodyData", JSON.stringify(bodyData));

    const apiMethod = updateEmployee(id, formData);

    apiMethod
      .then((res) => {
        if (res?.response?.status === 500) {
          // Handle error: ToastError(res?.response?.data?.data?.message);
        } else {
          // Handle success (e.g., GetData(), close the drawer)
          GetData();
          setOpenDrawer(false);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  };

  return (
    <div className="addRenderingContainer">
      <Box className="addContainerHeader">
        <Typography>
          {formType === "edit" ? "Edit" : formType === "view" ? "View" : "Add"}{" "}
          Edit Profile
        </Typography>
        <CloseIcon
          sx={{ cursor: "pointer" }}
          onClick={() => setOpenDrawer(false)}
        />
      </Box>
      <Divider sx={{ opacity: 1 }} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {({ touched, errors, setFieldValue, values }) => (
          <Form>
            <Box className="addContainerCenter" mb={1}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">First Name</Typography>
                  <Field
                    name="firstName"
                    className="InputField w-100"
                    placeholder="Enter First Name"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.firstName && errors.firstName && errors.firstName}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">Last Name</Typography>
                  <Field
                    name="lastName"
                    className="InputField w-100"
                    placeholder="Enter Last Name"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.lastName && errors.lastName && errors.lastName}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">Email</Typography>
                  <Field
                    name="email"
                    className="InputField w-100"
                    placeholder="Enter Email"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.email && errors.email && errors.email}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">Mobile</Typography>
                  <Field
                    name="mobileNo"
                    type="number"
                    className="InputField w-100"
                    placeholder="Enter Mobile Number"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.mobileNo && errors.mobileNo && errors.mobileNo}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">Date of Birth</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker", "DatePicker"]}>
                      <DatePicker
                        value={
                          values?.dateOfBirth
                            ? dayjs(values?.dateOfBirth)
                            : null
                        }
                        onChange={(e) =>
                          setFieldValue(
                            "dateOfBirth",
                            dayjs(e.$d).format("MM/DD/YYYY")
                          )
                        }
                        className="datePicker w-100"
                        disabled={disabled}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <div className="form-error">
                    {touched.dateOfBirth &&
                      errors.dateOfBirth &&
                      errors.dateOfBirth}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">
                    Emergency Information - Name
                  </Typography>
                  <Field
                    // disabled={ddisabled}
                    name="emergencyDetails.name"
                    className="InputField"
                    placeholder="Enter Name"
                  />
                  <div className="form-error">
                    {touched.emergencyDetails?.name &&
                      errors.emergencyDetails?.name &&
                      errors.emergencyDetails?.name}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">Relation</Typography>
                  <Field
                    // disabled={ddisabled}
                    name="emergencyDetails.relation"
                    className="InputField"
                    placeholder="Enter Relation"
                  />
                  <div className="form-error">
                    {touched.emergencyDetails?.relation &&
                      errors.emergencyDetails?.relation &&
                      errors.emergencyDetails?.relation}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">Mobile</Typography>
                  <Field
                    // disabled={ddisabled}
                    name="emergencyDetails.mobileNo"
                    type="number"
                    className="InputField"
                    placeholder="Enter Mobile Number"
                  />
                  <div className="form-error">
                    {touched.emergencyDetails?.mobileNo &&
                      errors.emergencyDetails?.mobileNo &&
                      errors.emergencyDetails?.mobileNo}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">
                    Door No / Street - Address
                  </Typography>
                  <Field
                    // disabled={ddisabled}
                    name="address.currentAddress.doorNo_street"
                    className="InputField w-100"
                    placeholder="Enter Door No & Street"
                    // onChange={(value) => setFieldValue("otherText", value)}
                  />
                  <div className="form-error">
                    {touched.address?.currentAddress?.doorNo_street &&
                      errors.address?.currentAddress?.doorNo_street &&
                      errors.address?.currentAddress?.doorNo_street}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">Place</Typography>
                  <Field
                    name="address.currentAddress.place"
                    className="InputField w-100"
                    placeholder="Enter Place"
                  />
                  <div className="form-error">
                    {touched.address?.currentAddress?.place &&
                      errors.address?.currentAddress?.place &&
                      errors.address?.currentAddress?.place}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">Pincode</Typography>
                  <Field
                    // disabled={ddisabled}
                    name="address.currentAddress.pincode"
                    type="number"
                    className="InputField w-100"
                    placeholder="Enter Pincode"
                  />
                  <div className="form-error">
                    {touched.address?.currentAddress?.pincode &&
                      errors.address?.currentAddress?.pincode &&
                      errors.address?.currentAddress?.pincode}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">District</Typography>
                  <Field
                    // disabled={ddisabled}
                    name="address.currentAddress.district"
                    className="InputField w-100"
                    placeholder="Enter District"
                  />
                  <div className="form-error">
                    {touched.address?.currentAddress?.district &&
                      errors.address?.currentAddress?.district &&
                      errors.address?.currentAddress?.district}
                  </div>
                </Grid>
                {formType === "view" ? (
                  <Grid item xs={12} sm={12} mt={1}>
                    <Typography className="inputLabel">View File</Typography>
                    {values?.file?.fileName ? (
                      <Typography className="fileLinkStyle">
                        {values?.file?.fileName}
                      </Typography>
                    ) : (
                      <Typography>No uploaded file</Typography>
                    )}
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={12} mt={1} className="File-Upload">
                    {/* <div className="wsh-form-control"> */}
                    <Typography className="inputLabel">Add Profile</Typography>
                    <FileUploader
                      handleChange={(e) => {
                        setFieldValue("file", e);
                        setFileName(e.name);
                        // setFileName(
                        //   selectedData?.file?.fileName
                        //     ? selectedData?.file?.fileName
                        //     : e.name
                        // );
                      }}
                      name="file"
                      multiple={false}
                      dropMessageStyle={{
                        color: "green",
                        border: "none",
                        borderRadius: "0px",
                      }}
                    />
                    <Box className="uploadIcon">
                      <CloudUploadOutlinedIcon />
                      {fileName ? (
                        <span>{fileName}</span>
                      ) : (
                        "Drag & Drop or click to upload files"
                      )}
                    </Box>
                    {/* <div className="form-error">
                        {touched.file && errors.file && errors.file}
                      </div>
                    </div> */}
                  </Grid>
                )}
              </Grid>
            </Box>
            <Grid className="addboxFooter">
              <Button
                className="cancelButton"
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="saveButton"
                sx={{ display: disabled ? "none" : "flex" }}
              >
                Save
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditProfileUser;
